module.exports = __webpack_public_path__ + "img/PL08669.03447a00.png";